import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type CloseBookingModalProps = InheritableModalProps & {
  onAction: () => void
}

const CloseBookingModal = ({ onAction, ...props }: CloseBookingModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={['fal', 'question-circle']} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({
            id: 'booking.modal.close.title',
            comment: 'Modal title',
            message: 'Ben je zeker dat je wil afsluiten?',
          })}
        </H3>

        <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'booking.modal.close.body',
            comment: 'Modal body',
            message:
              'De antwoorden op jouw vragen worden niet opgeslagen. Je kan natuurlijk steeds de afspraak later opnieuw boeken.',
          })}
        </P>
        <Button variant='Primary' onClick={onAction}>
          {t({
            id: 'booking.modal.close.secondary',
            comment: 'Modal secondary button',
            message: `Afsluiten`,
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose}>
          {t({
            id: 'booking.modal.close.primary',
            comment: 'Modal primary button',
            message: `Verder gaan met afspraak maken`,
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}

export { CloseBookingModal }
